import React from "react";
import { Download, Loader2 } from "lucide-react";
import { NdaPdfSource, useNdaPdfUrl } from "../../utils/hooks/scoping/useNdaPdfUrl";

interface NdaDownloadButtonProps {
  ndaSource: NdaPdfSource | null | undefined;
  className?: string;
  label?: string;
  loadingLabel?: string;
}

/**
 * Client-side NDA PDF download — mirrors the Solution Specialist flow
 * (react-pdf blob) without hitting the server-side nda-pdf endpoint.
 */
const NdaDownloadButton: React.FC<NdaDownloadButtonProps> = ({
  ndaSource,
  className = "",
  label = "Download Signed NDA",
  loadingLabel = "Preparing PDF…"
}) => {
  const { canDownload, isLoading, download } = useNdaPdfUrl(ndaSource);

  return (
    <button
      type="button"
      onClick={download}
      disabled={!canDownload || isLoading}
      className={className}
    >
      {isLoading ? (
        <>
          <Loader2 size={12} className="animate-spin" />
          {loadingLabel}
        </>
      ) : (
        <>
          <Download size={12} />
          {label}
        </>
      )}
    </button>
  );
};

export default NdaDownloadButton;
